import React from "react";
import WhatsappImage from "../../assets/images/Newsletter2.png";
import TwwiterImage from "../../assets/images/twitter.png";
import INstagramImage from "../../assets/images/instagram.png";

const socilaImage = [
  {
    id: 1,
    image: INstagramImage,
    Link: "https://instagram.com/thamer_info?igshid=MzRlODBiNWFlZA==",
  },
  {
    id: 2,
    image: TwwiterImage,
    Link: "https://twitter.com/ThamerAlsuwait",
  },
  {
    id: 3,
    image: WhatsappImage,
    // Link: "https://wa.me/96565111161",
  },
];
const whatsappData = [
  {
    id: 1,
    title: "رقم التواصل مع الحملة الانتخابية(رجال)",
    // phone: "96565111161",
  },
  {
    id: 2,
    title: "رقم التواصل مع الحملة الانتخابية(نساء)",
    // phone: "96565111161",
  },
];
function ContactSocial() {
  return (
    <div className="container">
      <div className="row d-flex justify-content-center align-items-center">
        {whatsappData.map((item, index) => {
          return (
            <div
              className="col-12 col-md-4 shadow p-3 my-3 bg-white rounded-3 mx-5 d-flex justify-content-around align-items-center"
              key={index}
            >
              <div>{item.title}</div>
              {item.phone && (
                <button
                  className="btn btn-outline-success"
                  onClick={() => {
                    window.open(`https://wa.me/${item.phone}`);
                  }}
                >
                  {item.phone} +
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div>
        <h2 className="text-center my-3 p-3">وسائل التواصل الاجتماعي</h2>
        <div className="d-flex justify-content-center align-items-center my-2">
          {socilaImage.map((item, index) => {
            return (
              <a
                href={item.Link}
                target="_blank"
                rel="noreferrer"
                key={index}
                className="text-decoration-none"
              >
                <img
                  src={item.image}
                  alt="socialImage"
                  className="img-fluid rounded-3 mx-2"
                  style={{ width: "60px" }}
                />
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ContactSocial;
